export default function TrialPageWall({ onClose }: { onClose: () => void }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink/40" onClick={onClose}>
            <div
                className="bg-surface border border-border rounded-2xl p-6 max-w-sm w-full mx-4 shadow-float"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 bg-info rounded-full flex items-center justify-center flex-shrink-0">
                        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <h3 className="text-base font-semibold text-ink">Accès limité en essai gratuit</h3>
                </div>
                <p className="text-sm text-ink-muted mb-4">
                    Les pages suivantes sont réservées aux abonnés. Passez à l'offre complète pour accéder à l'intégralité des résultats.
                </p>
                <div className="flex items-center gap-2">
                    <a
                        href="https://buy.stripe.com/3cIeVcfGAcLu1CFeTqgrS0e"
                        target="_blank"
                        rel="noreferrer"
                        className="flex-1 text-center bg-ink text-ink-inverse text-sm font-medium py-2 px-4 rounded-full hover:bg-ink/90 transition-colors duration-150"
                    >
                        Passer à Pro →
                    </a>
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm text-ink-muted hover:text-ink transition-colors duration-150"
                    >
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
}
